// Normalizes card expiry to MM/YY.
// DB values arrive as MM/YY, YY/MM, MMYY, or YYMM depending on the source.
// A month is always 01-12, so any part > 12 must be the year; the other is the month.
// Ambiguous case (both parts <= 12): assume input is already MM/YY.
export function formatCardExpiration(raw?: string | null): string {
  if (!raw) return "";
  const trimmed = raw.trim();
  if (!trimmed) return "";

  let a: string;
  let b: string;
  if (trimmed.includes("/")) {
    const parts = trimmed.split("/");
    if (parts.length !== 2) return trimmed;
    a = parts[0].trim();
    b = parts[1].trim();
  } else if (/^\d{4}$/.test(trimmed)) {
    a = trimmed.slice(0, 2);
    b = trimmed.slice(2);
  } else {
    return trimmed;
  }

  if (!/^\d{1,2}$/.test(a) || !/^\d{1,2}$/.test(b)) return trimmed;

  const aNum = Number(a);
  const bNum = Number(b);
  const aPad = a.padStart(2, "0");
  const bPad = b.padStart(2, "0");

  if (aNum > 12 && bNum <= 12) return `${bPad}/${aPad}`;
  if (bNum > 12 && aNum <= 12) return `${aPad}/${bPad}`;
  return `${aPad}/${bPad}`;
}
